import { GenericResponse } from 'src/js/model/api/response/generic-response';

export interface VideoInput {
  name: string;
  id: number;
  interfaceType: number;
  firFilter: boolean;
  colorSpace?: string;
  colorSpaceActual?: string;
  preferredResolution?: string;
  availableResolutions?: string[]; // only on supported devices & interfaceType
  squareDivisionCapture?: boolean;
}

export interface VideoInputResponse extends GenericResponse {
  name: string;
  id: number;
  interfaceType: number;
  firFilter: boolean;
}

export interface GetAllVideoInputsResponse {
  data: VideoInputResponse[];
}

export interface VideoInputViewModel extends VideoInput {}

export const mapVideoInputViewModel = (videoInput: VideoInputResponse): VideoInput => ({
  ...videoInput,
});

export const mapVideoInputsResponse = (response: GetAllVideoInputsResponse): VideoInput[] => {
  const mapped = response?.data.map((item) => mapVideoInputViewModel(item));
  return mapped;
};
